import http from './_http'

/**
 * 生成短链
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const clientParamAdd = (params = {}) => {
    return http({
        url: '/client/param/add',
        method: 'post',
        params: { data: params }
    });
}
/**
 * 解析短链
 * @returns {Promise | Promise<unknown>}
 * @param shortKey
 */
export const clientParamData = (shortKey) => {
    return http({
        url: '/client/param/data',
        method: 'get',
        params: { id: shortKey }
    });
}
